import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMeQuery } from '../../graphql/types';
import { isRegistrationOpen } from '../../utils/config';
import { useLotTimer } from '../../utils/use-lot-timer';
import { Button } from './button';

export function BidButton({
  startsAt,
  endsAt,
}: {
  startsAt?: string;
  endsAt: string;
}) {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth0();
  const me = useMeQuery({
    fetchPolicy: 'cache-first',
  });
  const { isLive } = useLotTimer({
    startsAt: startsAt ?? me.data?.activeAuction?.startsAt,
    endsAt: endsAt ?? me.data?.activeAuction?.endsAt,
  });

  const hasPaddle = me.data?.me?.paddle;

  const onButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (!isRegistrationOpen) {
      return;
    }

    const returnTo = `?returnTo=${encodeURIComponent(
      `${window.location.pathname}/bid`
    )}`;
    if (!isAuthenticated) {
      navigate(`/login${returnTo}`);
    } else if (!hasPaddle) {
      navigate(`/register${returnTo}`);
    } else {
      navigate(`${window.location.pathname}/bid`);
    }
  };

  return (
    <Button
      type="button"
      fullWidth
      disabled={!isRegistrationOpen || (!isLive && !!hasPaddle)}
      onClick={onButtonClick}
      loading={isAuthenticated && me.loading}
    >
      {!isRegistrationOpen
        ? 'Registration opening soon'
        : !isAuthenticated
        ? 'Login to bid'
        : hasPaddle
        ? 'Place bid'
        : 'Claim a paddle to bid'}
    </Button>
  );
}
